import { Maybe } from 'graphql/jsutils/Maybe';

import { DEFAULT_IMAGE } from '@/app/_constant/component.constant';
import { Media, MediaType } from '@/modules/core/gql/generated';

import { DEFAULT_IMAGE_CAROUSEL } from '../_components/shared/constant/component.constant';
import {
    CarouselItemInterface,
    R123SearchPageCardMediaInterface,
} from '../_components/shared/interface/search-page-card.interface';

export enum MediaTypeEnum {
    regular = 'REGULAR',
    cover = 'COVER',
    background = 'BACKGROUND',
    sitePlan = 'SITEPLAN',
    facility = 'FACILITY',
    youtube = 'YOUTUBE',
    brochure = 'BROCHURE',
    toc = 'TOC',
    logo = 'LOGO',
    vr360 = 'VR360',
    smartVideo = 'SMARTVIDEO',
}

export type MediaTypeInterface<T> = {
    [id in MediaTypeEnum]: T;
};

export type MediaItemInterface = {
    count: number;
    mediaInfo: MediaInfoInterface[];
};

type MediaInfoInterface = {
    formatUrl?: string;
    order: number;
    title?: string;
    thumbnailUrl?: string;
    url: string;
};
export const generateOGImage = (
    title?: string,
    medias?: Maybe<Maybe<Media>[]> | undefined,
): string => {
    if (!title || !medias || medias.length === 0) return '';
    const cover = medias.find((item) => item?.mediaType === MediaType.Cover);
    const regular = medias.find(
        (item) => item?.mediaType === MediaType.Regular,
    );

    let media;
    if (cover?.mediaInfo && cover.mediaInfo[0]) {
        const { formatUrl, order } = cover.mediaInfo[0];
        if (formatUrl) {
            media = {
                alt: title,
                id: `${title}-${formatUrl}-${order}`,
                src: formatUrl,
            };
        }
    } else if (regular?.mediaInfo && regular.mediaInfo[0]) {
        const { formatUrl, order } = regular.mediaInfo[0];
        if (formatUrl) {
            media = {
                alt: title,
                id: `${title}-${formatUrl}-${order}`,
                src: formatUrl,
            };
        }
    }
    return media
        ? media.src
        : 'https://www.rumah123.com/asset-core/images/assets/banner-large-opengraph.png';
};

export const generateMedia = ({
    medias,
    title,
    defaultImage,
}: {
    medias?: Maybe<Maybe<Media>[]> | undefined;
    title: string;
    defaultImage?: string;
}): {
    medias: R123SearchPageCardMediaInterface;
    photoCount: number;
    videoCount: number;
} => {
    if (!medias || medias.length === 0) {
        const defaultImageMediaa = DEFAULT_IMAGE_CAROUSEL[0];
        return {
            photoCount: 0,
            videoCount: 0,
            medias: [
                {
                    ...defaultImageMediaa,
                    src: defaultImage || DEFAULT_IMAGE_CAROUSEL[0].src,
                },
            ],
        };
    }

    let cover;
    let regular;
    let videoCount = 0;
    for (let i = 0; i < medias.length; i++) {
        const media = medias[i];
        if (!media) continue;

        if (media.mediaType === MediaType.Cover) {
            if (media.mediaInfo) {
                cover = media.mediaInfo;
            }
        } else if (media.mediaType === MediaType.Regular) {
            if (media.mediaInfo) {
                regular = media.mediaInfo;
            }
        } else if (media.mediaType === MediaType.Youtube) {
            if (media.mediaInfo) {
                videoCount = videoCount + media.mediaInfo.length;
            }
        } else if (media.mediaType === MediaType.Smartvideo) {
            if (media.mediaInfo) {
                videoCount = videoCount + media.mediaInfo.length;
            }
        }
    }

    const photos = [...(cover || []), ...(regular || [])]
        .map((item, index): CarouselItemInterface => {
            return {
                alt: title,
                id: `${item?.formatUrl}-${index}`,
                sizes: `(max-width: 360px) and (max-resolution: 1dppx) 360px, (max-width: 360px) and (max-resolution: 2dppx) 720px, 750px`,
                src: generateFormattedUrlSrcSet(item?.formatUrl || ''),
            };
        })
        // Remove duplicate src object value
        // Usually happens if cover using one of regular image
        .filter(
            (mappedMedia, index, self) =>
                self.findIndex(
                    (selfIndex) => selfIndex.src === mappedMedia.src,
                ) === index,
        );

    const photoCount = photos.length;

    return {
        medias: photos.map(({ src, ...res }) => ({
            ...res,
            src: src.replace('${width}x${height}-${scale}', '720x420-crop'),
        })),
        photoCount,
        videoCount,
    };
};

const generateFormattedUrlSrcSet = (
    formattedUrl: string | undefined,
): string => {
    if (!formattedUrl) return DEFAULT_IMAGE;
    if (/\{/g.test(formattedUrl)) return formattedUrl.replace(/\{/g, '${');

    return formattedUrl;
};
